<template>
  <div class="sidebar-pinned">
    <Navbar/>
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="header-icon-wrap">
          <i class="fe fe-users"></i>
        </div>
        <div class="flex-grow-1">
          <h2 class="page-header-title">Offline Enrollees</h2>
          <p class="page-header-subtitle">Records saved on this device pending sync</p>
        </div>
        <div class="header-badge" v-if="studentCount > 0">
          <span class="badge-count">{{ studentCount }}</span>
          <span class="badge-label">Pending Sync</span>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- Sync alert -->
        <div class="alert-sync d-flex align-items-center mb-4" v-if="studentCount > 0">
          <i class="fe fe-upload-cloud mr-3" style="font-size:1.4rem;"></i>
          <div class="flex-grow-1">
            <strong>{{ studentCount }} record{{ studentCount > 1 ? 's' : '' }} ready to sync</strong>
            <p class="mb-0 small" style="opacity:.8;">Upload these records to the server when you're back online.</p>
          </div>
          <router-link :to="{ path: '/offline-sync' }" class="btn btn-sync ml-3">
            <i class="fe fe-upload-cloud mr-1"></i> Sync Now
          </router-link>
        </div>

        <!-- Enrollees Table Card -->
        <div class="card info-card shadow-sm">
          <div class="info-card-header d-flex align-items-center justify-content-between">
            <span><i class="fe fe-list mr-2"></i> Saved Enrollees</span>
            <span class="badge badge-light text-dark font-weight-bold">{{ studentCount }}</span>
          </div>
          <div class="card-body p-0">
            <AllEnrolleesOffline
              :students="students"
              @add-item="addStudent"
              @remove-item="refreshStudent"
              @update-item="refreshStudent"
            />
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </div>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin
     import AllEnrolleesOffline from "./AllEnrolleesOffline.vue";
     import { initJsStore } from "./../../../service/idb_service";
     import { StudentService } from "./../../../service/student_service";
     import { Global } from "./../../../global";

export default {
  components: {
     Navbar, Loading, AllEnrolleesOffline
  },
  async beforeCreate() {
    try {
      const isDbCreated = await initJsStore();
      if (isDbCreated) {
        console.log("db created");
        // prefill database
      } else {
        console.log("db opened");
      }
    } catch (ex) {
      console.error(ex);
      alert(ex.message);
      Global.isIndexedDbSupported = false;
    }
  },
  mounted() {
    this.refreshStudent();
  },
  data(){
    return{
      isLoading: false,
      fullPage: true,
      states:"",
      clients:"",
      state:"",
      students: [],
      studentCount: 0,
      lga_states:"",
      register:{
                firstname:"",
                lastname:"",
                email:"",
                phone_number:"",
                type:"client",
                username:"",
                state:"",
                lga:"",
                ward:"",
                address:"",
            }
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))

  },
  methods:{
    async refreshStudent() {
      this.isLoading = true
      this.students = await new StudentService().getStudents();
      this.studentCount = this.students.length;
      let total = this.students.length;
      localStorage.setItem('synctotal', total)
      this.isLoading = false

    },
    addStudent(student) {
      this.students.push(student);
      this.studentCount++;
    }


  },
  created(){
    //
  }

}
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  padding: 36px 40px 56px;
  display: flex;
  align-items: center;
  gap: 18px;
}
.header-icon-wrap {
  background: rgba(255,255,255,0.15);
  border-radius: 14px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
}
.page-header-title  { font-size: 1.6rem; font-weight: 800; margin: 0 0 4px; }
.page-header-subtitle { margin: 0; opacity: .82; font-size: .9rem; }

.header-badge {
  text-align: center;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 12px;
  padding: 10px 20px;
  flex-shrink: 0;
}
.badge-count { display: block; font-size: 2rem; font-weight: 800; line-height: 1; }
.badge-label { font-size: .7rem; opacity: .8; letter-spacing: .06em; text-transform: uppercase; }

.alert-sync {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  border-radius: 12px;
  padding: 16px 20px;
}
.btn-sync {
  background: rgba(255,255,255,0.2);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.35);
  border-radius: 8px;
  font-weight: 600;
  font-size: .85rem;
  white-space: nowrap;
  padding: 8px 16px;
  transition: background 0.15s;
}
.btn-sync:hover { background: rgba(255,255,255,0.3); color: #fff; }

.info-card { border-radius: 12px; border: 1px solid #e9ecef; overflow: hidden; }
.info-card-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  font-weight: 600;
  font-size: .85rem;
  padding: 10px 16px;
}
</style>
